export const APP_VERSION = '1.33.0';

type AppReleaseNote = {
    version: string;
    date: string;
    notes: string[];
};

export const RELEASE_NOTES: AppReleaseNote[] = [
    {
        version: '1.33.0',
        date: '2026-09-14',
        notes: [
            'Filtrar chamados por status de atribuição',
            'Vincular ocorrência ao suporte',
            'Ajustar sugestão de mudança de status em Respondido ao Dealer',
            'Exibir número do chamado no aviso de ocorrências para o mesmo chassi',
            'Permitir exportação completa do chamado em PDF',
            'Ajuste no tempo de movimentação automática da etapa “Respondido ao Dealer” para “Finalizado”',
            'Ajustes no fluxo de vincular ocorrência (evitar sobrescrever dados e filtrar ocorrências por chassi no form de criação)',
            'Ajustes na ordenação por data de criação e atualização',
            'Ajustes na visualização de PDF (zoom e possibilidade de passar de um anexo para outro sem fechar o modal)',
            'Ajuste no modal de ocorrências existentes para o chassi (lista com os números de chamados abertos) e no modal de mover chamado para outra etapa (combo com as opções de etapa para mover o chamado)',
            'Criar suporte a partir de chamado do Monitor de Manutenção (ajuste no nome, de Suporte para Atendimento)',
        ],
    },
    {
        version: '1.32.0',
        date: '2026-09-04',
        notes: [
            '38028 - Preservar comentário não enviado durante a navegação no chamado',
            '38033 - Ordenar chamados por tempo de criação ou tempo na etapa',
            '38330 - Ajustar ações de edição do chamado de Suporte Volkstotal'
        ],
    },
    {
        version: '1.31.1',
        date: '2026-08-27',
        notes: [
            'Remoção do filtro por atribuição'
        ],
    },
    {
        version: '1.31.0',
        date: '2026-08-27',
        notes: [
            '35947 - Manter filtros aplicados na listagem de chamados',
            '35532 - Exibir número do chamado nos dados da solicitação',
            '36182 - Ajustar informações exibidas no card do chamado',
            '36951 - Permitir duplicação de chamados',
            '36958 - Restringir atribuição de chamados para usuários Volkswagen'
        ],
    },
    {
        version: '1.30.1',
        date: '2026-08-25',
        notes: [
            'Ajuste na geolocalização do acionamento na chamada do serviço de criação de rotas'
        ],
    },
    {
        version: '1.30.0',
        date: '2026-08-19',
        notes: [
            'Implementa volks essencial'
        ],
    },
    {
        version: '1.29.1',
        date: '2026-08-13',
        notes: [
            'Ajuste na validação dos formulários de atendimento'
        ],
    },
    {
        version: '1.29.0',
        date: '2026-08-12',
        notes: [
            '35533 - Sugerir mudança de etapa após alterações no chamado',
            '35535 - Organizar anexos por data e hora de inclusão',
            '35724 - Tornar obrigatórios os dados adicionais em todos os assuntos',
            '35725 - Disponibilizar pré-visualização de arquivos PDF',
            '35728 - Permitir edição dos dados do chamado após a abertura',
            '35729 - Revisar campos exibidos nos dados do veículo',
            '35926 - Implementar regras de negócio para gestão dos chamados'
        ],
    },
];
